import fetcher from 'lib/utils/fetcher'
import React, { FunctionComponent } from 'react'
import useSWR from 'swr'
import Quote from './Quote'

interface ITheOfficeQuoteProps {
  title?: string
}

interface IOfficeQuote {
  quote: string
  character: string
}

const API_URL = 'https://officeapi.akashrajpurohit.com/quote/random'

const TheOfficeQuote: FunctionComponent<ITheOfficeQuoteProps> = ({ title }): JSX.Element => {
  const { data, error } = useSWR<IOfficeQuote, Error>(API_URL, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  })

  if (!data || error) {
    return null
  }

  return (
    <div>
      <p>{title}</p>
      <Quote quote={data.quote} name={data.character} />
    </div>
  )
}

export default TheOfficeQuote
